import { z } from "zod";
import { hasAtLeastOneField, requiredText, optionalText, requiredBoolean, requiredId, requiredNumber, optionalBoolean, optionalId, optionalDefaultBoolean, optionalNonEmptyText } from "../lib/schemas";
import { ProviderStatus } from "../types/status.types";
const optionalEmail = z.email().trim().optional().nullable();
//Para Get O Delete por el Id que se pasa por Param
export const providerIdParamSchema = z.object({
    providerId: requiredId,
});
//Respuesta del GET de un tercero por Id
export const getProviderOutputSchema = z.object({
    id: requiredId,
    name: requiredText,
    nit: requiredText,
    category: requiredText,
    tag: optionalText,
    phone: optionalText,
    email: optionalEmail,
    operating: requiredBoolean,
    requirementsTotal: requiredNumber,
    requirementsDone: requiredNumber,
    status: z.enum(ProviderStatus),
});
//Envio de datos para CREATE del tercero
export const createProviderInputSchema = z.object({
    name: requiredText,
    nit: requiredText,
    phone: optionalText,
    email: optionalEmail,
    operating: optionalDefaultBoolean(true),
    categoryId: requiredId,
    tagId: optionalId,
});
//Envio de datos para UPDATE del tercero por el Id que se pasa por Param
export const updateProviderInputSchema = z.object({
    name: optionalNonEmptyText,
    nit: optionalNonEmptyText,
    phone: optionalText,
    email: optionalEmail,
    operating: optionalBoolean,
    isObsolete: optionalBoolean,
    categoryId: optionalId,
    tagId: optionalId,
}).refine(hasAtLeastOneField, {
    message: "At least one field is required",
});
